import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-single-benefits',
  templateUrl: './single-benefits.component.html',
  styleUrls: ['./single-benefits.component.scss'],
})
export class SingleBenefitsComponent implements OnInit {
  newRating = 0;
 
  constructor(private router: ActivatedRoute) {}

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  passValueVote(updateValue: number) {
    this.newRating = updateValue;
  }
}
